import {AddressModel, addressModelFactory} from "../address/address.model";

const searchValueKeys = [
  "id",
  "serialNumber",
  "assetTag",
  "building",
  "floor",
  "floorMapId",
  "productNumber",
  "model",
  "deviceKey",
  "siteName",
];

export interface SelectableAsset {
  id: string;
  serialNumber: string;
  assetTag: string;
  building: string;
  floor: string;
  floorMapId: string;
  productNumber: string;
  model: string;
  deviceKey: string;
  updatedDate: string;
  originalInstallDate: string;
  selected: boolean;
  selectedNew: boolean;
  disabled: boolean;
  status?: string;
  statusKey?: string;
  statusDetail?: string;
  siteExistsInK2?: string;
  siteExistsInITSM?: string;
  existingK2SiteAddress: AddressModel;
  sitePhysicalAddress: AddressModel;
  siteName?: string;
  assetId?: string;
  sentToSAP?: boolean;
  installed?: boolean;
  quicksilver?: boolean;
  orderNumber?: string;
  itsmConsumableAutoFulfillment?: boolean;
  itsmLongLifeConsumableAutoFulfillment?: boolean;
  itsmMaintenanceAutoFulfillment?: boolean;
  category?: string;
  travelZone?: string;
  deliveryTypeModifier?: string;
  deliveryLocationModifier?: string;
  partsLogisticsSuppliesModifier?: string;
  coverageWindowModifier?: string;
  responseTimeModifier?: string;
  repairTimeModifier?: string;
  expressExchange?: string;
  depotRepair?: string;
  supportType?: string;
  healthCheck?: string;

  children?: SelectableAsset[];

  type: "asset" | "accessory" | "asset removal" | "";
  searchValues: string[];
}

export function updateSelectableAssetModelSearchValues(asset: SelectableAsset) {
  let value;
  const values = [];
  const valuesMap = {};

  for (const key of searchValueKeys) {
    value = asset[key];
    if (value !== undefined && !Object.prototype.hasOwnProperty.call(valuesMap, value)) {
      valuesMap[value] = true;
      values.push(value);
    }
  }

  if (asset.children) {
    for (const child of asset.children) {
      for (const key of searchValueKeys) {
        value = child[key];
        if (value !== undefined && !Object.prototype.hasOwnProperty.call(valuesMap, value)) {
          valuesMap[value] = true;
          values.push(value);
        }
      }
    }
  }

  asset.searchValues = values;
}

export function selectableAssetModelFactory(row: any, selected?: boolean) {
  return {
    id: row.id || "",
    serialNumber: row.serialNumber || "",
    assetTag: row.assetTag || "",
    building: row.building || "",
    originalInstallDate: row.originalInstallDate || "",
    installDate: row.installDate || "",
    updatedDate: row.updatedDate || "",
    isFutureFleet: row.isFutureFleet || "",
    floor: row.floor || "",
    floorMapId: row.floorMapId || "",
    productNumber: row.productNumber || "",
    model: row.model || "",
    itsmConsumableAutoFulfillment: !!row.itsmConsumableAutoFulfillment,
    itsmLongLifeConsumableAutoFulfillment: !!row.itsmLongLifeConsumableAutoFulfillment,
    itsmMaintenanceAutoFulfillment: !!row.itsmMaintenanceAutoFulfillment,
    deviceKey: row.deviceKey || "",
    selected: false,
    selectedNew: selected,
    disabled: !!row.disabled,
    status: row.status || "",
    statusKey: row.statusKey || "",
    statusDetail: row.statusDetail || "",
    siteExistsInK2: row.siteExistsInK2 || false,
    siteExistsInITSM: row.siteExistsInITSM || false,
    existingK2SiteAddress: addressModelFactory(row.existingK2SiteAddress),
    sitePhysicalAddress: addressModelFactory(row.sitePhysicalAddress),
    siteName: row.siteName || "",
    assetId: row.assetId || "",
    sentToSAP: !!row.sentToSAP,
    quicksilver: !!row.quicksilver,
    customHeading1: row.customHeading1 || "",
    customHeading2: row.customHeading2 || "",
    customHeading3: row.customHeading3 || "",
    customHeading4: row.customHeading4 || "",
    customHeading5: row.customHeading5 || "",
    category: row.category || "",
    travelZone: row.travelZone || "",
    deliveryTypeModifier: row.deliveryTypeModifier || "",
    deliveryLocationModifier: row.deliveryLocationModifier || "",
    partsLogisticsSuppliesModifier: row.partsLogisticsSuppliesModifier || "",
    coverageWindowModifier: row.coverageWindowModifier || "",
    responseTimeModifier: row.responseTimeModifier || "",
    repairTimeModifier: row.repairTimeModifier || "",
    expressExchange: row.expressExchange || "",
    depotRepair: row.depotRepair || "",
    supportType: row.supportType || "",
    healthCheck: row.healthCheck || "",
    installed: !!row.installed,
    orderNumber: row.orderNumber || "",
    children: [],
    type: row.type || "",
    searchValues: [],
  } as SelectableAsset;
}

export function selectableAssetModelListFactory(rows: any[], selectedIds: {[key: string]: boolean}) {
  return rows.map((it) => {
    const selected = selectedIds[it.id];
    return selectableAssetModelFactory(it, selected);
  });
}
